import { InputHTMLAttributes, ReactNode } from 'react'
import cn from 'classnames'

import './styles.scss'

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode
  reverse?: boolean
}

export const Radio = ({ style, className, label, reverse, ...rest }: Props) => {
  const labelJsx = label && <span className="radio-label">{label}</span>

  return (
    <label className={cn('radio', className)} style={style}>
      {reverse && labelJsx}
      <input type="radio" className="radio-input" {...rest} />
      <svg
        width="20"
        height="20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="outline"
        aria-hidden="true"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0 2a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z"
          fill="var(--red-tertiary)"
        ></path>
      </svg>
      <svg
        width="20"
        height="20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="circle"
        aria-hidden="true"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0 2a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z"
          fill="var(--red-tertiary)"
        ></path>
        <path d="M15 10a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z" fill="var(--red-tertiary)"></path>
      </svg>
      {!reverse && labelJsx}
    </label>
  )
}
